// Custom react-router Link that preloads routes on mouseenter
// https://medium.com/maxime-heckel/react-lazy-a-take-on-preloading-views-cc90be869f14
import {
  useLocation as reactRouterUseLocation,
  useNavigate as reactRouterUseNavigate,
  matchPath,
  useHref,
  useLinkClickHandler,
  useMatch as reactRouterUseMatch,
} from 'react-router'
import type { LinkProps, NavigateFunction, To /*, LinkProps */ } from 'react-router'
// import { lazyWithPreload } from 'react-lazy-with-preload'
import type { Location } from 'types'
import { forwardRef } from 'react'

export { useParams } from 'react-router'

// const Register = lazyWithPreload(() => import('../Register/Register'))
// const RegisterApplicant = lazyWithPreload(() => import('../Register/RegisterApplicant'))
// const RegisterCompany = lazyWithPreload(() => import('../Register/RegisterCompany'))
// const Login = lazyWithPreload(() => import('../Login'))
// const BeginPasswordReset = lazyWithPreload(() => import('../Login/BeginPasswordReset'))
// const UpdatePassword = lazyWithPreload(() => import('../Login/UpdatePassword'))
// const Error = lazyWithPreload(() => import('../Error'))
// const Market = lazyWithPreload(() => import('ui/Market'))
// const Report = lazyWithPreload(() => import('ui/Report'))
// const CompanyJobs = lazyWithPreload(() => import('../Companies/Jobs'))
// const NewJob = lazyWithPreload(() => import('../Companies/NewJob'))
// const EditJob = lazyWithPreload(() => import('../Companies/EditJob'))
// const DescribeJob = lazyWithPreload(() => import('../Companies/DescribeJob'))
// const JobsApplicants = lazyWithPreload(() => import('../Companies/JobsApplicants'))
// // const ApplicantJobs = lazyWithPreload(() => import('../Applicants/Jobs'))

// // Account
// const Account = lazyWithPreload(() => import('../Account'))
// const AccountVisibility = lazyWithPreload(() => import('../Account/Visibility'))
// const AccountBilling = lazyWithPreload(() => import('../Account/Billing'))
// const AccountAPI = lazyWithPreload(() => import('../Account/API'))
// // const AccountUpdateApplicant = lazyWithPreload(() => import('../Register/UpdateApplicant'))
// // const AccountUpdateCompany = lazyWithPreload(() => import('../Register/UpdateCompany'))
// const AccountAPIDashboard = lazyWithPreload(() => import('../Account/API/Dashboard'))
// const AccountAPISearch = lazyWithPreload(() => import('../Account/API/Search'))

// // Teams
// const Teams = lazyWithPreload(() => import('../Teams'))
// const TeamsProfiles = lazyWithPreload(() => import('../Teams/Profiles'))
// const TeamsDistribution = lazyWithPreload(() => import('../Teams/Distribution/Distribution'))
// const TeamsEvaluation = lazyWithPreload(() => import('../Teams/Evaluation/Evaluation'))
// const TeamsBoard = lazyWithPreload(() => import('../Teams/Board/Board'))

// // Prepare routes for preloading
// const routesToPreload = [
//   // Common
//   { path: '/', component: Login },
//   { path: '/register', component: Register },
//   { path: '/register/applicant', component: RegisterApplicant },
//   { path: '/register/company', component: RegisterCompany },
//   { path: '/login', component: Login },
//   { path: '/begin-password-reset', component: BeginPasswordReset },
//   { path: '/update-password/:token', component: UpdatePassword },
//   { path: '/error/:message', component: Error },
//   { path: '/market', component: Market },
//   { path: '/report', component: Report },
//   // Account
//   { path: '/account', component: Account },
//   // { path: '/account', component: AccountUpdateApplicant },
//   // { path: '/account', component: AccountUpdateCompany },
//   { path: '/account/visibility', component: AccountVisibility },
//   { path: '/account/billing', component: AccountBilling },
//   { path: '/account/api', component: AccountAPI },
//   { path: '/account/api/:appId', component: AccountAPIDashboard },
//   { path: '/account/api/:appId/:currentPage', component: AccountAPISearch },

//   { path: '/companies/:companyId/jobs', component: CompanyJobs },
//   { path: '/companies/:companyId/jobs/:jobId/report', component: Report },

//   // Applicant
//   // { path: '/jobs', component: ApplicantJobs },
//   { path: '/jobs/:jobId/report', component: Report },
//   // Company
//   // { path: '/jobs', component: CompanyJobs },
//   { path: '/jobs/new', component: NewJob },
//   { path: '/jobs/:jobId', component: JobsApplicants },
//   { path: '/jobs/:jobId/edit', component: EditJob },
//   { path: '/jobs/:jobId/describe', component: DescribeJob },
//   { path: '/jobs/:jobId/report', component: Report },
//   { path: '/jobs/:jobId/applicants/:applicantId/report', component: Report },
//   // Teams
//   { path: '/teams', component: Teams },
//   { path: '/teams/:teamId/profiles', component: TeamsProfiles },
//   { path: '/teams/:teamId/distribution', component: TeamsDistribution },
//   { path: '/teams/:teamId/evaluation', component: TeamsEvaluation },
//   { path: '/teams/:teamId/board', component: TeamsBoard },
// ]

// const findComponentForRoute = (to: To, routes: typeof routesToPreload) => {
//   const matchingRoute = routes.find(route => matchPath(
//     typeof to === 'string' ? to : (to?.pathname ?? ''),
//     route.path,
//   ))

//   // // TODO: we still don't have nested routesToPreload to recurse
//   // if (matchingRoute && matchingRoute.routes)
//   //   return findComponentForRoute(location, matchingRoute.routes)

//   return matchingRoute ? matchingRoute.component : null
// }

// const preloadRouteComponent = (to: To) => {
//   const component = findComponentForRoute(to, routesToPreload)
//   if (component && component.preload)
//     component.preload()
// }

export function normalizeTo(to: To, ignoreType?: boolean) {
  const windowSearchParams = new URLSearchParams(window.location.search)
  const token = windowSearchParams.get('token')
  const lang = windowSearchParams.get('lang')
  const clientId = windowSearchParams.get('clientId')
  const ref = windowSearchParams.get('ref')
  const order = windowSearchParams.get('o')
  const type = windowSearchParams.get('type')

  if (!token && !clientId && !ref && !order && !type) return to

  if (typeof to === 'string') {
    // @ts-expect-error TODO deprecate this
    const url = new URL(to, window.location)
    if (token && !url.searchParams.has('token')) url.searchParams.set('token', token)
    if (lang && !url.searchParams.has('lang')) url.searchParams.set('lang', lang)
    if (clientId && !url.searchParams.has('clientId')) url.searchParams.set('clientId', clientId)
    if (ref && !url.searchParams.has('ref')) url.searchParams.set('ref', ref)
    if (!ignoreType && order && !url.searchParams.has('o')) url.searchParams.set('o', order)
    if (!ignoreType && type && !url.searchParams.has('type')) url.searchParams.set('type', type)
    return `${url.pathname}${url.search}`
  }

  const searchParams = new URLSearchParams(to.search)
  if (token && !searchParams.has('token')) searchParams.set('token', token)
  if (lang && !searchParams.has('lang')) searchParams.set('lang', lang)
  if (clientId && !searchParams.has('clientId')) searchParams.set('clientId', clientId)
  if (ref && !searchParams.has('ref')) searchParams.set('ref', ref)
  if (!ignoreType && order && !searchParams.has('o')) searchParams.set('o', order)
  if (!ignoreType && type && !searchParams.has('type')) searchParams.set('type', type)
  return { ...to, search: `?${searchParams.toString()}` }
}

export function useNavigate() {
  const navigate = reactRouterUseNavigate()
  return ((to, options) => navigate(normalizeTo(to), options)) as NavigateFunction
}

export function useNavigateWithoutnormalizeTo() {
  return reactRouterUseNavigate()
}

export function useLocation() {
  return reactRouterUseLocation() as Location
}

export function useBackgroundLocation() {
  return ((reactRouterUseLocation() as Location).state?.background ?? reactRouterUseLocation()) as Location
}

export const useMatch = reactRouterUseMatch

export const useBackgroundMatch: typeof reactRouterUseMatch = (pattern) =>
  matchPath(pattern, useBackgroundLocation().pathname)

// https://github.com/microsoft/TypeScript/issues/25760#issuecomment-405931434
type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
type WithOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

// https://reactrouter.com/docs/en/v6/upgrading/v5#remove-link-component-prop
const Link: React.ForwardRefExoticComponent<
  WithOptional<LinkProps, 'to'> & {
    removeLink?: boolean
    ignoreType?: boolean
    $disabled?: boolean
    href?: string
  } & React.RefAttributes<HTMLAnchorElement>
> = forwardRef(
  (
    {
      onClick,
      replace = false,
      state,
      target,
      to,
      removeLink, // Custom
      ignoreType, // Custom
      $disabled, // Custom
      ...rest
    },
    ref,
  ) => {
    const href = useHref(normalizeTo(to ?? '', ignoreType))
    const handleClick = useLinkClickHandler(normalizeTo(to ?? '', ignoreType), {
      replace,
      state,
      target,
    })
    if (to == null && rest.href != null)
      return (
        <a {...rest} ref={ref}>
          {rest.children}
        </a>
      )

    if (removeLink)
      return (
        <span {...rest} ref={ref}>
          {rest.children}
        </span>
      )

    return (
      <a
        {...rest}
        href={href}
        onClick={(event) => {
          onClick?.(event)
          if (!event.defaultPrevented) {
            handleClick(event)
          }
        }}
        ref={ref}
        target={target}
        // onMouseEnter={() => preloadRouteComponent(to ?? '')}
      />
    )
  },
)

Link.displayName = 'Link'

export default Link
